import { routerStyxie } from '@/router/styxieBridge'
import { useReviewsDashboardStore } from '@/stores/reviewsDashboard'

// The reviews dashboard is client-side routed: the action boots the shared
// router shell; the payload hydrates the store on full page loads.
Styxie.Initializers.ReviewsDashboard = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => useReviewsDashboardStore(pinia).initialize(props)
})
